module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAMAAACNQ/wIAAAAY1BMVEUAAAD/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNr/yNp+QPkZAAAAIHRSTlMA91f77+O9tKGJb0cvIfHw5t3Vz8vBqZt/Y08pJxoXDEEBZRcAAACtSURBVBjTVc9XEsQgDANQkV4gvVfuf8qNccLC+7FGwyQ2jHJuhWjnEp990K9hf59U2qrMQym0Q0gAvfb0wMZpLIqR04bJzByP3MQJMY0GRkM5Rkgj5SqlHCKi0XHVUY6QaBJQE5iYoOB1FikXXrDAxcESF5D5VQbgCN0mPPDI/EdECedLCuBDrBzsjr8mvsF4R7uxPY5P/TtrauoTjpWqFZ6E7vWpKFKAL7B/+wGJTB9hYCrhUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/map-active.png
// module id = 218
// module chunks = 0